module.exports = __webpack_public_path__ + "static/media/icon-one.fa5e9749.webp";